/* eslint-disable import/prefer-default-export */
import { ContactPageError } from './Form/_props'

export const contactPageErrors: Record<ContactPageError, string> = {
    contactDoesNotExists: "Erreur: ce correspondant n'existe pas",
    contactCreationForbidden: "La création de correspondants n'est pas disponible pour cet établissement",
    unknownError:
        'Une erreur est survenue, vous pouvez recharger la fiche correspondant ou retourner à la liste des correspondants.',
}
